  import { Component, OnInit } from '@angular/core';
  import { takeUntil } from 'rxjs';
  import { AuthServiceProxy, ClientsCountResponse, OrdersCountResponse, RevenueResponse, StatisticsServiceProxy, UserModel } from '../../../shared/service-proxies/event-service-proxy';
  import { DestroyService } from '../../services/destroy/destroy.service';
import { AuthService } from '../../services/auth/auth.service';
  @Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
    standalone: false,
    providers: [DestroyService],
  })
  export class DashboardComponent implements OnInit {
    public revenue: RevenueResponse = new RevenueResponse();
    public ordersCount: OrdersCountResponse = new OrdersCountResponse();
    public clientsCount: ClientsCountResponse = new ClientsCountResponse();

    user: UserModel = new UserModel();
    isUserLoading: boolean = true;

    isClientsLoading: boolean = true;
    isOrdersLoading: boolean = true;
    isRevenueLoading: boolean = true;

    userFirstName: string = '';
    userLastName: string = '';

    constructor(private authService: AuthService, private _statisticsService: StatisticsServiceProxy, private destroyService: DestroyService, private _authService: AuthServiceProxy) {}

    ngOnInit(): void {
      this.initialData();
      this.getCurrentUser();
    }

    initialData() {
      this.getClientsCount();
      this.getOrdersCount();
      this.getRevenue();
    }

    getClientsCount() {
      this._statisticsService.getClientsCount(this.authService.getCompanyId())
      .pipe(takeUntil(this.destroyService.onDestroy$))
        .subscribe(res => {
          this.isClientsLoading = false;
          this.clientsCount = res;
          console.log(this.clientsCount);
        }, error => {
          this.isClientsLoading = false;
          this.clientsCount.currentCount = 0;
          this.clientsCount.percentageChange = 0;
      })
    }
    getRevenue() {
      this._statisticsService.getRevenue(this.authService.getCompanyId())
      .pipe(takeUntil(this.destroyService.onDestroy$))
        .subscribe(res => {
          this.isOrdersLoading = false;
          this.revenue = res;
          console.log(this.revenue);
      }, error => {
          this.isOrdersLoading = false;
          this.revenue.currentRevenue = 0;
          this.revenue.percentageChange = 0;
      })
    }
    getOrdersCount() {
      this._statisticsService.getOrdersCount(this.authService.getCompanyId())
      .pipe(takeUntil(this.destroyService.onDestroy$))
        .subscribe(res => {
          this.isRevenueLoading = false;
          this.ordersCount = res;
      }, error => {
          this.isRevenueLoading = false;
          this.ordersCount.currentOrders = 0;
          this.ordersCount.percentageChange = 0;
      })
    }
    
      getTrend(value: number): 'positive' | 'negative' | 'neutral' {
        if (value > 0) return 'positive';
        if (value < 0) return 'negative';
        return 'neutral';
      }
    
     initial() {
        this.userFirstName = this.user.firstname ? this.user.firstname : '';
        this.userLastName = this.user.lastname ? this.user.lastname : '';
      }

    getCurrentUser() {
        this._authService.me()
            .pipe(takeUntil(this.destroyService.onDestroy$))
            .subscribe(res => {
              this.user = res;
              this.isUserLoading = false;
              this.initial();
            }, error => {
              this.isUserLoading = false;
        })
    }
  }
